import helper from './helper'
import lodash from './lodash'
import { mask } from 'vue-the-mask'

export default (app) => {
  app.use(helper)
  app.use(lodash)
  // vue-the-mask's default export has no `install` under Vite: register the
  // directive itself.
  app.directive('mask', mask)
}
